import AddUser from '@/components/addUser/';
import AuditConfig from '@/components/auditConfig/';
import Audits from '@/components/audits/';
import ChecklistConfig from '@/components/checklistConfig/';
import Checklists from '@/components/checklists/';
import Companies from '@/components/companies/';
import CompanyConfig from '@/components/companies/companyConfig';
// import Home from '@/components/home/index';
import Login from '@/components/login/index';
import Logout from '@/components/logout/index';
import Main from '@/components/Main';
import redirectToPortal from '@/components/redirect/';
import Roles from '@/components/roles/';
import Shifts from '@/components/shifts/';
import TaskConfig from '@/components/taskConfig/index';
import Tasks from '@/components/tasks/index';
import UsersPermissions from '@/components/usersPermissions/index';
import WorkingAreas from '@/components/workingAreas/index';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      // name: 'Home',
      component: Main,
      children: [
        {
          path: 'company/:companyId',
          name: 'Home SuperUser',
          component: Main,
        },
        {
          path: '',
          name: 'Home',
          component: Main,
        }],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/configuration/WorkingAreas',
      // name: 'workingAreas',
      component: WorkingAreas,
      children: [
        {
          path: '',
          name: 'workingAreas',
          // component: WorkingAreas,
        },
        {
          path: 'company/:companyId',
          name: 'workingAreas SuperUser',
          // component: WorkingAreas,
        }],
    },
    {
      path: '/configuration/UsersPermissions',
      // name: 'User & Permissions',
      component: UsersPermissions,
      children: [
        {
          path: '',
          name: 'User & Permissions',
          // component: UsersPermissions,
        },
        {
          path: 'company/:companyId',
          name: 'User & Permissions SuperUser',
          // component: UsersPermissions,
        }],
    },
    {
      path: '/configuration/AddUser',
      // name: 'Add User',
      component: AddUser,
      props: { type: 'user' },
      children: [
        {
          path: '',
          name: 'Add User',
          // component: AddUser,
        },
        {
          path: ':userId',
          name: 'Change User',
          // component: AddUser,
        },
        {
          path: 'company/:companyId',
          name: 'Add User SuperUser',
          // component: AddUser,
        },
        {
          path: ':userId/company/:companyId',
          name: 'Change User SuperUser',
          // component: AddUser,
        }],
    },
    {
      path: '/configuration/AddAdmin',
      // name: 'Add Admin',
      component: AddUser,
      props: { type: 'admin' },
      children: [
        {
          path: '',
          name: 'Add Admin',
          // component: AddUser,
        },
        {
          path: ':userId',
          name: 'Change Admin',
          // component: AddUser,
        },
        {
          path: 'company/:companyId',
          name: 'Add Admin SuperUser',
          // component: AddUser,
        },
        {
          path: ':userId/company/:companyId',
          name: 'Change Admin SuperUser',
          // component: AddUser,
        }],
    },
    {
      path: '/configuration/Shifts',
      // name: 'Days, times, shifts',
      component: Shifts,
      children: [
        {
          path: '',
          name: 'Days, times, shifts',
        },
        {
          path: 'company/:companyId',
          name: 'Days, times, shifts SuperUser',
        }],
    },
    {
      path: '/configuration/Roles',
      // name: 'Roles',
      component: Roles,
      children: [
        {
          path: '',
          name: 'Roles',
        },
        {
          path: 'company/:companyId',
          name: 'Roles SuperUser',
        }],
    },
    {
      path: '/constructor/TaskConstructor',
      name: 'Task Configuration',
      component: TaskConfig,
      children: [
        {
          path: ':taskId',
          name: 'Task Configuration Change',
          // component: TaskConfig,
        },
        {
          path: ':taskId/company/:companyId',
          name: 'Task Configuration Change SuperUser',
          // component: TaskConfig,
        },
        {
          path: 'company/:companyId',
          name: 'Task Configuration SuperUser',
          // component: TaskConfig,
        },
      ],
    },
    {
      path: '/constructor/TaskConstructor/duplicate',
      name: 'Task Configuration Duplicate',
      component: TaskConfig,
      props: { duplicate: true },
      children: [
        {
          path: ':taskId',
          name: 'Task Configuration Duplicate',
          // component: TaskConfig,
        },
        {
          path: ':taskId/company/:companyId',
          name: 'Task Configuration Duplicate SuperUser',
        },
      ],
    },
    {
      path: `${process.env.START_URL}/constructor/Tasks`,
      name: 'Tasks',
      component: Tasks,
      children: [
        {
          path: '',
          name: 'Tasks',
        },
        {
          path: 'company/:companyId',
          name: 'Tasks SuperUser',
        }],
    },
    {
      path: `${process.env.START_URL}/constructor/new_tasks`,
      name: 'New tasks',
      component: redirectToPortal,
      props: { route: 'tasktemplates' },
      children: [
        {
          path: '',
          name: 'New Tasks',
        },
        {
          path: 'company/:companyId',
          name: 'New Tasks SuperUser',
        }],
    },
    {
      path: `${process.env.START_URL}/constructor/new_task`,
      name: 'New task',
      component: redirectToPortal,
      props: { route: 'tasktemplates/new' },
      children: [
        {
          path: '',
          name: 'New Task',
        },
        {
          path: 'company/:companyId',
          name: 'New Task SuperUser',
        }],
    },
    {
      path: '/constructor/ChecklistConstructor',
      // name: 'Checklist Configuration',
      component: ChecklistConfig,
      children: [
        {
          path: '',
          name: 'Checklist Configuration',
        },
        {
          path: 'company/:companyId',
          name: 'Checklist Configuration SuperUser',
        }],
    },
    {
      path: '/constructor/ChecklistConstructor/:checklistId',
      // name: 'Checklist Configuration Change',
      component: ChecklistConfig,
      children: [
        {
          path: '',
          name: 'Checklist Configuration Change',
        },
        {
          path: 'company/:companyId',
          name: 'Checklist Configuration Change SuperUser',
        }],
    },
    {
      path: '/constructor/ChecklistConstructor/duplicate/:checklistId',
      component: ChecklistConfig,
      props: { duplicate: true },
      children: [
        {
          path: '',
          name: 'Checklist Configuration Duplicate',
        },
        {
          path: 'company/:companyId',
          name: 'Checklist Configuration Duplicate SuperUser',
        },
      ],
    },
    {
      path: '/constructor/Checklists',
      // name: 'Checklists',
      component: Checklists,
      children: [
        {
          path: '',
          name: 'Checklists',
        },
        {
          path: 'company/:companyId',
          name: 'Checklists SuperUser',
        }],
    },
    {
      path: `${process.env.START_URL}/constructor/new_checklists`,
      name: 'New checklists',
      component: redirectToPortal,
      props: { route: 'checklisttemplates' },
      children: [
        {
          path: '',
          name: 'New Checklists',
        },
        {
          path: 'company/:companyId',
          name: 'New Checklists SuperUser',
        }],
    },
    {
      path: `${process.env.START_URL}/constructor/new_checklist`,
      name: 'New checklist',
      component: redirectToPortal,
      props: { route: 'checklisttemplates/new' },
      children: [
        {
          path: '',
          name: 'New Checklist',
        },
        {
          path: 'company/:companyId',
          name: 'New Checklist SuperUser',
        }],
    },
    {
      path: '/constructor/AuditConstructor',
      // name: 'Audit Configuration',
      component: AuditConfig,
      children: [
        {
          path: '',
          name: 'Audit Configuration',
        },
        {
          path: 'company/:companyId',
          name: 'Audit Configuration SuperUser',
        }],
    },
    {
      path: '/constructor/AuditConstructor/:auditId',
      // name: 'Audit Configuration Change',
      component: AuditConfig,
      children: [
        {
          path: '',
          name: 'Audit Configuration Change',
        },
        {
          path: 'company/:companyId',
          name: 'Audit Configuration Change SuperUser',
        }],
    },
    {
      path: '/constructor/AuditConstructor/duplicate/:auditId',
      component: AuditConfig,
      props: { duplicate: true },
      children: [
        {
          path: '',
          name: 'Audit Configuration Duplicate',
        },
        {
          path: 'company/:companyId',
          name: 'Audit Configuration Duplicate SuperUser',
        },
      ],
    },
    {
      path: '/constructor/Audits',
      // name: 'Audits',
      component: Audits,
      children: [
        {
          path: '',
          name: 'Audits',
        },
        {
          path: 'company/:companyId',
          name: 'Audits SuperUser',
        }],
    },
    {
      path: `${process.env.START_URL}/constructor/new_audits`,
      name: 'New audits',
      component: redirectToPortal,
      props: { route: 'audittemplates' },
      children: [
        {
          path: '',
          name: 'New Audits',
        },
        {
          path: 'company/:companyId',
          name: 'New Audits SuperUser',
        }],
    },
    {
      path: `${process.env.START_URL}/constructor/new_audit`,
      name: 'New audit',
      component: redirectToPortal,
      props: { route: 'audittemplates/new' },
      children: [
        {
          path: '',
          name: 'New Audit',
        },
        {
          path: 'company/:companyId',
          name: 'New Audit SuperUser',
        }],
    },
    {
      path: '/companies',
      name: 'Companies SuperUser',
      component: Companies,
    },
    {
      path: '/companyConfig',
      name: 'Add Company SuperUser',
      component: CompanyConfig,
    },
    {
      path: '/companyConfig/:companyId',
      name: 'Change Company SuperUser',
      component: CompanyConfig,
    },
  ],
});

function hasQueryParams(route) {
  return !!Object.keys(route.query).length;
}

// pass SAML login redirect parameters to login
router.beforeEach((to, from, next) => {
  if (!hasQueryParams(to) && hasQueryParams(from) && to.name === 'Home') {
    next({ name: to.name, query: from.query, params: from.params });
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js